export default "__VITE_ASSET__CVXN9Qfs__"